import React from "react";
import Header from "../component/Header";

const Spin = () => {
  return (
    <>
      <Header />
      <div className="body">
        <div data-v-4f5f518c className="roulette">
          <div data-v-4f5f518c className="roulette_wrap">
            <div data-v-4f5f518c className="roulette_main">
              <div data-v-4f5f518c className="roulette-period">
                2024-09-05 - 2030-12-31
              </div>
              <div data-v-4f5f518c className="roulette_main_numberTimes_left">
                <div data-v-4f5f518c>
                  <div data-v-4f5f518c>
                    <span data-v-4f5f518c className="font-weight-bold title">
                      20
                    </span>
                    <span data-v-4f5f518c>coins</span>
                    <br data-v-4f5f518c />
                    /swing
                  </div>
                </div>
              </div>
              <div
                data-v-4f5f518c
                className="roulette_main_wrap roulette_P8_N8 luckywheel"
              >
                <ul
                  data-v-4f5f518c
                  className="roulette_main_part roulette_main_part-8 luckywheel"
                  style={{
                    "-webkit-transform": "rotate(0deg)",
                    "-ms-transform": "rotate(0deg)",
                    transform: "rotate(0deg)",
                  }}
                >
                  <li data-v-4f5f518c className="roulette_main_part_list">
                    <div data-v-4f5f518c className="roulette_main_part_color" />
                    <span data-v-4f5f518c className="roulette_main_part_award">
                      ৳1
                    </span>
                  </li>
                  <li data-v-4f5f518c className="roulette_main_part_list">
                    <div data-v-4f5f518c className="roulette_main_part_color" />
                    <span data-v-4f5f518c className="roulette_main_part_award">
                      ৳5
                    </span>
                  </li>
                  <li data-v-4f5f518c className="roulette_main_part_list">
                    <div data-v-4f5f518c className="roulette_main_part_color" />
                    <span data-v-4f5f518c className="roulette_main_part_award">
                      ৳11
                    </span>
                  </li>
                  <li data-v-4f5f518c className="roulette_main_part_list">
                    <div data-v-4f5f518c className="roulette_main_part_color" />
                    <span data-v-4f5f518c className="roulette_main_part_award">
                      ৳22
                    </span>
                  </li>
                  <li data-v-4f5f518c className="roulette_main_part_list">
                    <div data-v-4f5f518c className="roulette_main_part_color" />
                    <span data-v-4f5f518c className="roulette_main_part_award">
                      ৳33
                    </span>
                  </li>
                  <li data-v-4f5f518c className="roulette_main_part_list">
                    <div data-v-4f5f518c className="roulette_main_part_color" />
                    <span data-v-4f5f518c className="roulette_main_part_award">
                      ৳88
                    </span>
                  </li>
                  <li data-v-4f5f518c className="roulette_main_part_list">
                    <div data-v-4f5f518c className="roulette_main_part_color" />
                    <span data-v-4f5f518c className="roulette_main_part_award">
                      ৳222
                    </span>
                  </li>
                  <li data-v-4f5f518c className="roulette_main_part_list">
                    <div data-v-4f5f518c className="roulette_main_part_color" />
                    <span data-v-4f5f518c className="roulette_main_part_award">
                      ৳666
                    </span>
                  </li>
                </ul>
                <div
                  data-v-4f5f518c
                  className="roulette_main_btn"
                  style={{
                    "background-image": 'url("/assets/new/spinbutton.webp")',
                    "background-position": "center center",
                    "background-size": "cover",
                  }}
                />
                <div data-v-4f5f518c className="roulette_main_numberTimes">
                  <div data-v-4f5f518c>
                    <div data-v-4f5f518c>
                      <span data-v-4f5f518c>0</span>
                      <span data-v-4f5f518c>coins</span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-4f5f518c className="roulette_main_coin">
                <span data-v-4f5f518c className="roulette_main_coinWrap">
                  <img
                    data-v-4f5f518c
                    src="/assets/new/1.webp"
                    className="roulette_main_coin_1"
                  />
                </span>
                <span data-v-4f5f518c className="roulette_main_coinWrap">
                  <img
                    data-v-4f5f518c
                    src="/assets/new/3.webp"
                    className="roulette_main_coin_2"
                  />
                </span>
                <span data-v-4f5f518c className="roulette_main_coinWrap">
                  <img
                    data-v-4f5f518c
                    src="/assets/new/2.webp"
                    className="roulette_main_coin_3"
                  />
                </span>
                <span data-v-4f5f518c className="roulette_main_coinWrap">
                  <img
                    data-v-4f5f518c
                    src="/assets/new/4.webp"
                    className="roulette_main_coin_4"
                  />
                </span>
                <span data-v-4f5f518c className="roulette_main_coinWrap">
                  <img
                    data-v-4f5f518c
                    src="/assets/new/5.webp"
                    className="roulette_main_coin_5"
                  />
                </span>
                <span data-v-4f5f518c className="roulette_main_coinWrap">
                  <img
                    data-v-4f5f518c
                    src="/assets/new/6.webp"
                    className="roulette_main_coin_6"
                  />
                </span>
              </div>
            </div>
            <div
              data-v-4f5f518c
              style={{
                "-webkit-box-pack": "center",
                "-webkit-justify-content": "center",
                "-ms-flex-pack": "center",
                "justify-content": "center",
                display: "flex",
                "-webkit-align-items": "center",
                "-webkit-box-align": "center",
                "-ms-flex-align": "center",
                "align-items": "center",
              }}
            >
              <button
                data-v-4f5f518c
                type="button"
                className="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default luckywheelbtn active"
                style={{
                  "-webkit-transform": "scale(1.1)",
                  "-ms-transform": "scale(1.1)",
                  transform: "scale(1.1)",
                }}
              >
                <span className="v-btn__content" />
              </button>
              <button
                data-v-4f5f518c
                type="button"
                className="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default luckywheelEx1btn"
              >
                <span className="v-btn__content" />
              </button>
              <button
                data-v-4f5f518c
                type="button"
                className="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default luckywheelEx2btn"
              >
                <span className="v-btn__content" />
              </button>
            </div>
            <div data-v-4f5f518c className="roulette_minor">
              <ul data-v-4f5f518c className="roulette_awards">
                <li data-v-4f5f518c className="roulette_awards_item">
                  <div data-v-4f5f518c>
                    <div data-v-4f5f518c className="roulette_awards_medals" />
                    <div data-v-4f5f518c className="roulette_awards_prize">
                      <img
                        data-v-4f5f518c
                        src="/assets/new/668b59dd38201.webp"
                      />
                    </div>
                    <div data-v-4f5f518c className="roulette_awards_text">
                      ৳5
                    </div>
                  </div>
                </li>

                <li data-v-4f5f518c className="roulette_awards_item">
                  <div data-v-4f5f518c>
                    <div data-v-4f5f518c className="roulette_awards_medals" />
                    <div data-v-4f5f518c className="roulette_awards_prize">
                      <img
                        data-v-4f5f518c
                        src="/assets/new/668b59dd38222.webp"
                      />
                    </div>
                    <div data-v-4f5f518c className="roulette_awards_text">
                      ৳22
                    </div>
                  </div>
                </li>
                <li data-v-4f5f518c className="roulette_awards_item">
                  <div data-v-4f5f518c>
                    <div data-v-4f5f518c className="roulette_awards_medals" />
                    <div data-v-4f5f518c className="roulette_awards_prize">
                      <img
                        data-v-4f5f518c
                        src="/assets/new/668b59dd38233.webp"
                      />
                    </div>
                    <div data-v-4f5f518c className="roulette_awards_text">
                      ৳33
                    </div>
                  </div>
                </li>
                <li data-v-4f5f518c className="roulette_awards_item">
                  <div data-v-4f5f518c>
                    <div data-v-4f5f518c className="roulette_awards_medals" />
                    <div data-v-4f5f518c className="roulette_awards_prize">
                      <img
                        data-v-4f5f518c
                        src="/assets/new/668b59dd38243.webp"
                      />
                    </div>
                    <div data-v-4f5f518c className="roulette_awards_text">
                      ৳88
                    </div>
                  </div>
                </li>
                <li data-v-4f5f518c className="roulette_awards_item">
                  <div data-v-4f5f518c>
                    <div data-v-4f5f518c className="roulette_awards_medals" />
                    <div data-v-4f5f518c className="roulette_awards_prize">
                      <img
                        data-v-4f5f518c
                        src="/assets/new/668b59dd38277.webp"
                      />
                    </div>
                    <div data-v-4f5f518c className="roulette_awards_text">
                      ৳222
                    </div>
                  </div>
                </li>
                <li data-v-4f5f518c className="roulette_awards_item">
                  <div data-v-4f5f518c>
                    <div data-v-4f5f518c className="roulette_awards_medals" />
                    <div data-v-4f5f518c className="roulette_awards_prize">
                      <img
                        data-v-4f5f518c
                        src="/assets/new/668b59dd38666.webp"
                      />
                    </div>
                    <div data-v-4f5f518c className="roulette_awards_text">
                      ৳666
                    </div>
                  </div>
                </li>
              </ul>
              {/* <div data-v-4f5f518c className="roulette_winner">
                <div data-v-4f5f518c className="roulette_winner_wrap">
                  <div
                    data-v-4f5f518c
                    className="roulette_winner_head winnerList"
                  >
                    <div data-v-4f5f518c className="roulette_winner_headItem">
                      Winner's list
                    </div>
                    <div data-v-4f5f518c className="roulette_winner_headItem">
                      Winning record
                    </div>
                    <div
                      data-v-4f5f518c
                      className="roulette_winner_headCursor leftMost"
                    />
                  </div>
                  <div data-v-4f5f518c className="roulette_winner_slider">
                    <ul
                      data-v-4f5f518c
                      className="roulette_winner_list"
                      style={{}}
                    >
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>rafi****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>rafi****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>bulbu*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          22.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>chit****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          22.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>rubel*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>ibrahi******</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01911*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>isla****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          55.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>isla****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          33.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>isla****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          33.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>isla****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          33.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>isla****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          222.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>isla****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          222.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>saif****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>isla****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          222.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>saif****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>sadi****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>apon****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>apon****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          33.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>50sa****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>esra****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          22.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>esra****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          22.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>bab***</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>tane****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>samm****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01781*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>nove****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>fir***</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          33.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>swap****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>swap****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>swap****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          33.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>swap****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          55.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>swap****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          55.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>swap****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          55.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01726*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01726*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>has***</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01785*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01892*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          33.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01892*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          88.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01892*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          33.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01892*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          55.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01892*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          88.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>11223*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>11223*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>bab***</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          33.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>bab***</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>suban*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          11.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>mram****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          55.00
                        </span>
                      </li>
                      <li data-v-4f5f518c className="roulette_winner_listItem">
                        <span data-v-4f5f518c className="roulette_winner_date">
                          2026-01-19
                        </span>
                        <span data-v-4f5f518c>01338*****</span>
                        <span data-v-4f5f518c className="roulette_winner_prize">
                          22.00
                        </span>
                      </li>
                    </ul>
                    <ul
                      data-v-4f5f518c
                      className="roulette_winner_list"
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div> */}
              <div
                style={{ marginTop: "50px" }}
                data-v-4f5f518c
                className="roulette_rule"
              >
                <h3 data-v-4f5f518c className="roulette_rule_title">
                  Terms &amp; Conditions:{" "}
                </h3>
                <p data-v-4f5f518c className="rouletteRule_text" />
                <p data-v-4f5f518c>
                  <strong data-v-4f5f518c>
                    <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                      Babu88 LUCKY WHEEL
                    </span>
                  </strong>
                </p>
                <p data-v-4f5f518c>
                  <strong data-v-4f5f518c>
                    <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                      Spin Lucky Wheel to get extra CASH!
                    </span>
                  </strong>
                </p>
                <p data-v-4f5f518c />
                <div data-v-4f5f518c className="luckyWheel-divWrapper">
                  <div
                    data-v-4f5f518c
                    className="luckyWheelDetail-card v-card v-sheet v-sheet--outlined theme--light"
                  >
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-8">
                        <span data-v-4f5f518c>Member Types</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>All Members</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-8">
                        <span data-v-4f5f518c>Frequency</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>UNLIMITED</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-8">
                        <span data-v-4f5f518c>Bonus / Rebate Percentage</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>N/A</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-8">
                        <span data-v-4f5f518c>Max Bonus / Rebate</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳999</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-8">
                        <span data-v-4f5f518c>Game Providers</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>All Game Providers</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-8">
                        <span data-v-4f5f518c>Turnover Requirement</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>x1</span>
                      </div>
                    </div>
                  </div>
                </div>
                <p data-v-4f5f518c>
                  <strong data-v-4f5f518c>
                    <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                      How to get coins :
                    </span>
                  </strong>
                </p>
                <p data-v-4f5f518c>
                  1. Make a minimum deposit of ৳200. Every ৳100 you deposited
                  get 1 coin. Example: If you deposit ৳1000, you will get 10
                  coins
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    2. Daily check in , check in everyday and get coins for
                    free.
                  </span>
                </p>
                <p data-v-4f5f518c />
                <p data-v-4f5f518c>
                  <strong data-v-4f5f518c>
                    <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                      Bonus Conditions:
                    </span>
                  </strong>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    1. This promotion is applicable to All Game Providers.
                  </span>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    2. There is no limitation how many times members can spin.
                  </span>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    3. Members are required to fulfill a turnover amount x1
                    bonus amount in order to transfer or withdraw.
                  </span>
                </p>
                <p data-v-4f5f518c />
                <p data-v-4f5f518c>
                  <strong data-v-4f5f518c>
                    <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                      Coins per spin:
                    </span>
                  </strong>
                </p>
                <div data-v-4f5f518c className="luckyWheel-divWrapper">
                  <div
                    data-v-4f5f518c
                    className="luckyWheelDetail-card v-card v-sheet v-sheet--outlined theme--light"
                  >
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>Wheel of Bronze</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>Wheel of Silver</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>Wheel of Gold</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>20 coins</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>60 coins</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>500 coins</span>
                      </div>
                    </div>
                  </div>
                </div>
                <p data-v-4f5f518c />
                <div data-v-4f5f518c className="luckyWheel-divWrapper">
                  <div
                    data-v-4f5f518c
                    className="luckyWheelDetail-card v-card v-sheet v-sheet--outlined theme--light"
                  >
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>Wheel of Bronze</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>Wheel of Silver</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>Wheel of Gold</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>৳1111</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳5555</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳88888</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>৳888</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳1222</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳18888</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>৳666</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳777</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳8888</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>৳222</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳444</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳3888</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>৳88</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳222</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳1888</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>৳33</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳88</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳888</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>৳22</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳55</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳444</span>
                      </div>
                    </div>
                    <div data-v-4f5f518c className="row row-border no-gutters">
                      <div data-v-4f5f518c className="col-border col col-4">
                        <span data-v-4f5f518c>৳11</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳33</span>
                      </div>
                      <div data-v-4f5f518c className="col-padding col col-4">
                        <span data-v-4f5f518c>৳222</span>
                      </div>
                    </div>
                  </div>
                </div>
                <p data-v-4f5f518c />
                <p data-v-4f5f518c>
                  <strong data-v-4f5f518c>
                    <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                      Terms &amp; Conditions:{" "}
                    </span>
                  </strong>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    1. All promotion offers are limited to only one per person.
                    Any shared or same household address, IP address, email
                    address, telephone number,credit or debit card and/or
                    e-payment account, or shared device (e.g. school, public
                    library or workplace) are not allowed.
                  </span>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    2. Members are not allowed to bet at the same time
                    (Banker/Player, Big/Small, Black/White, Single/Double, etc.)
                    .
                  </span>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    3. Any bets resulting in void, tie, canceled, or made on
                    opposite sides with the same outcome will not be counted as
                    a valid turnover . Members are not allowed to bet at the
                    same time and roulette (black small/red large) or more than
                    18 numbers. Only 1/4 from your total bets will be counted as
                    turnover for bets made on Roulette.
                  </span>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    4. All bonuses are not allowed to be used to purchase FREE
                    GAMES, FREE SPINS or any similar type of feature. All bonus
                    funds, money won and deposited may be removed immediately if
                    member is suspected or caught.
                  </span>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    5. Participating members must accept and comply with all the
                    terms mentioned above as well as all relevant rules and
                    regulations stated on the babu99 app.
                  </span>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    6. babu99 reserves the right to freeze/block a members
                    account if suspected of any fraudulent or suspicious
                    activities.
                  </span>
                </p>
                <p data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                    7. babu99 reserves the right to modify, cancel, suspend or
                    terminate the promotion and/or change the terms of the said
                    promotion at any time without prior notice.
                  </span>
                </p>
                <p data-v-4f5f518c>
                  <strong data-v-4f5f518c>
                    <span data-v-4f5f518c style={{ "font-size": "14px" }}>
                      General Babu88 Terms &amp; Conditions apply.
                    </span>
                  </strong>
                </p>
              </div>
            </div>
          </div>

          <div data-v-4f5f518c className="roulette_popup">
            <div data-v-4f5f518c className="roulette_popup_wrap">
              <div data-v-4f5f518c className="roulette_popup_box">
                <p data-v-4f5f518c>Congratulations go to</p>
                <h3 data-v-4f5f518c />
                <img data-v-4f5f518c src="https://csi.20icipp.comundefined" />
                <div data-v-4f5f518c className="roulette_popup_btnWrap">
                  <div data-v-4f5f518c className="roulette_popup_btn disabled">
                    Roll again
                  </div>
                </div>
                <div data-v-4f5f518c className="roulette_popup_btn">
                  OK
                </div>
                <div data-v-4f5f518c className="roulette_popup_close">
                  <div data-v-4f5f518c />
                </div>
              </div>
            </div>
          </div>
          <app-dialog-status
            data-v-4f5f518c
            dialogtitle
            dialogmessages
            dialogfields
            dialogbuttons
          />
        </div>
      </div>{" "}
    </>
  );
};

export default Spin;
